<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          MOQ No：{{ formData.amzMoqNo ? formData.amzMoqNo : 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.amzMoqStatus === 'Y'
              ? 'success'
              : formData.amzMoqStatus === 'N'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_amzMoqStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_amzMoqName') || '产品起定量名称'"
            prop="amzMoqName"
          >
            <el-input
              v-model="formData.amzMoqName"
              clearable
              size="mini"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              maxlength="200"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            prop="scmCode"
            :label="$l('INDEX.form_label_scm') || '工厂'"
          >
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmPartners"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              :selectedLabel.sync="formData.scmName"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.form_placeholder_buyer') || '采购人员'"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('INDEX.tips_select_placeholder') || '请选择采购人员'
              "
              :selectedLabel.sync="formData.buyerName"
              size="mini"
              filterable
              clearable
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('form_label_moq_unit') || '起定量单位'"
            prop="moqUnit"
          >
            <el-input v-model="formData.v_moqUnit" readonly size="mini">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2" v-if="!disabled">
          <el-form-item :label="''">
            <br />
            <el-button
              type="primary"
              size="mini"
              @click="save()"
              style="width: 100%"
              >{{ $l('INDEX.btn_save') || '保存' }}</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <MoqMaterial
      v-if="moqMaterialDisabled"
      class="mt-1"
      :amzMoqCode="amzMoqCode"
      :disabled="disabled"
    />

    <SkuMoqMaterial
      class="mt-2"
      :amzMoqCode="amzMoqCode"
      :disabled="disabled"
      ref="skuMoqMaterial"
      :scmCode="scmCode"
      :moqMaterialDisabled="moqMaterialDisabled"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import MoqMaterial from '../moq-material'
import SkuMoqMaterial from '../sku-moq-material'

export default {
  mixins: [EditLoading],
  components: { MoqMaterial, SkuMoqMaterial },
  props: {
    amzMoqCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      formData: {
        scmCode: '',
      },
      scmCode: '',
      rules: {
        amzMoqName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        moqUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        scmCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    moqMaterialDisabled() {
      return this.formData.moqUnit === 'Fabric'
    },
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.amzMoqCode) return
      this.$api
        .ecomAmzMoqDetailApi({
          amzMoqCode: this.amzMoqCode,
        })
        .then((res) => {
          this.formData = { ...res.body }
          this.scmCode = this.formData.scmCode
          console.log(this.scmCode)
          this.$refs.skuMoqMaterial.queryData(this.scmCode)
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()

      this.$api
        .ecomAmzMoqSaveApi(this.formData)
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          if (!this.amzMoqCode) {
            this.closeCurPage()
          } else {
            this.getData()
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
